import React, { useState, useEffect } from "react";
import PageLayout from "../../Dashboard/MainContent/pages/PageLayout";
import Navbar, {
  NavBrand,
  NavItem,
  NavItemButton,
} from "../../../layouts/Navbar";
import { useRedux } from "../../../Hooks/useRedux";
import { Icon } from "@iconify/react";
import Logo from "../../../layouts/Logo";
import Button from "../../../layouts/Button";

import { useNavigate } from "react-router-dom";
import { FormikProvider, Form, useFormik } from "formik";
import * as Yup from "yup";

// actions
import { getProfile, signUp } from "../../../redux/actions/authAction";

import CustomInput from "../../../layouts/CustomInput";
import { toast } from "react-toastify";
import consoleHelper from "../../../utils/consoleHelper";
import SpinLoader from "../../../layouts/SpinLoader";
import DotLoader from "../../../layouts/DotLoader";
import Footer from "../../Footer";
import { set } from "react-ga";
import MetaDecorator from "../../../utils/MetaDecorator";

const HomePage = () => {
  const navigate = useNavigate();

  const {
    data: {
      sidebar,
      user: { user },
    },
    dispatch,
  } = useRedux(["sidebar", "user"]);

  const [isGettingUser, setIsGettingUser] = useState(false);
  const [privacy, setPrivacy] = useState(null);

  useEffect(() => {
    setIsGettingUser(() => true);
    dispatch(
      getProfile({
        err: (m) => {
          setIsGettingUser(() => false);
        },
        done: (m) => {
          setIsGettingUser(() => false);
        },
      })
    );
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  function startLoading() {
    setIsLoading(() => true);
  }
  function stopLoading() {
    setIsLoading(() => false);
  }
  const initialValues = {
    fullname: "",
    email: "",
    password: "",
  };

  const handleSignup = (formData, e) => {
    if (!privacy) {
      return setPrivacy(false);
    }
    startLoading();

    dispatch(
      signUp(formData, {
        err: (m) => {
          stopLoading();
          m && toast.error(m);
        },
        done: (m) => {
          stopLoading();
          m && toast.success(m);
          localStorage.setItem("veracc", "signup-verify");
          localStorage.setItem("vereml", formData.email);
          navigate("/auth/verify");
        },
      })
    );
  };

  const RegistrationSchema = Yup.object().shape({
    fullname: Yup.string()
      .min(1, "Name must be more than 1 character!")
      .max(80, "Name must be less than 120 character!")
      .required("Name is required!")
      .nullable(),
    email: Yup.string()
      .email("Must be a valid email!")
      .max(255, "Email must be less than 255 characters!")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Please provide a Password, which have more than 8 characters")
      .required("Password is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: RegistrationSchema,
    onSubmit: handleSignup,
  });

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <>
      <MetaDecorator
        title="BigBlueButton RTMP Live Streaming "
        description="Stream your BigBlueButton sessions to multiple social media channels or live streaming platforms."
      />

      <div className="max-w-[1280px] w-full mx-auto py-5 px-5 1300px:px-0 overflow-hidden">
        {/* main Container  */}
        <div className="flex flex-col items-center md:flex-row w-full">
          {/* left side */}
          <div className="w-full md:max-w-[45%] max-h-screen h-full">
            <h1
              className="font-extrabold xs:tracking-[1px] sm:tracking-[1px] md:tracking-[1px] lg:tracking-[1px] xs:text-[18px] sm:text-2xl md:text-[40px] lg:text-[40px]  text-primary-100 test text-center md:text-left xs:max-w-[500px] md:max-w-full mx-auto md:mx-0"
              //   style={{ letterSpacing: "4px" }}
            >
              BigBlueButton RTMP Live Streaming as a Service
            </h1>
            <p className=" text-primary-50 mt-3 mx-auto md:mx-0 text-center md:text-left xs:text-md xs:max-w-[450px] sm:text-lg sm:max-w-[450px] md:text-lg md:max-w-[500px] ">
              An easy web interface with scalable infrastructure to allow your team to manage RTMP Live Stream of multiple BigBlueButton sessions together 
              without any Upfront Cost or Fixed Cost. It will cost you for per minute of usage. FIRST 10 Minutes is FREE to TRY without any Payment.
            </p>

            

            {/* signup */}
            <div className="max-w-[328px] xs:mx-auto md:mx-0">
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <div className="mt-5">
                      <CustomInput
                        className="w-full"
                        // title="Name"
                        placeholder="Full Name"
                        autoFocus
                        autoComplete="name"
                        {...getFieldProps("fullname")}
                        error={Boolean(touched.fullname && errors.fullname)}
                        helperText={touched.fullname && errors.fullname}
                      />
                    </div>

                    <div className="mt-5">
                      <CustomInput
                        className="w-full"
                        // title="Email Address"
                        placeholder="Email Address.."
                        typr="email"
                        autoComplete="email"
                        {...getFieldProps("email")}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </div>

                    <div className="mt-5">
                      <CustomInput
                        className="w-full"
                        // title="Password"
                        type="password"
                        placeholder="Password"
                        {...getFieldProps("password")}
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                      />
                    </div>

                    <div className="mt-6 pl-1 text-primary-100">
                      <div className="flex items-center gap-4">
                        <input
                          className="cursor-pointer w-5 h-5 text-secondary-100"
                          type="checkbox"
                          id="privacy"
                          onChange={(e) => {
                            setPrivacy(() => e.target.checked);
                          }}
                        />

                        {/* I agree with Terms & Conditions and Privacy Policy of Bigbluebutton Host */}
                        <div className="flex gap-2">
                          <div className="flex-nowrap shrink-0">
                            I agree with
                          </div>
                          <div className="flex-nowrap shrink-0">
                            <a
                              href="https://bigbluebutton.host/terms-and-conditions"
                              target="_blank"
                              rel="noreferrer"
                              className="transition-all cursor-pointer text-secondary-100 hover:underline hover:text-secondary-200"
                            >
                              T&C
                            </a>
                          </div>
                          <div className="flex-nowrap shrink-0">
                            <span className="">and</span>
                          </div>
                          <div className="flex-nowrap shrink-0">
                            <a
                              href="https://bigbluebutton.host/privacy-and-policy"
                              target="_blank"
                              rel="noreferrer"
                              className="transition-all cursor-pointer text-secondary-100 hover:underline hover:text-secondary-200"
                            >
                              Privacy Policy
                            </a>
                          </div>
                          {/* <div className="flex-nowrap shrink-0">
                            <span className="">of</span>
                          </div>
                          <div className="flex-nowrap shrink-0">
                            <a
                              href="https://bigbluebutton.host/"
                              target="_blank"
                              rel="noreferrer"
                              className="transition-all cursor-pointer text-secondary-100 hover:underline hover:text-secondary-200"
                            >
                              Bigbluebutton Host
                            </a>
                          </div> */}
                        </div>
                      </div>

                      {privacy === false && (
                        <span className="mt-3 block ml-2 text-red-500">
                          Please accept our T&C and privacy policy
                        </span>
                      )}
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="mt-16 w-full flex justify-center">
                      <SpinLoader />
                    </div>
                  ) : (
                    <div className="mt-8">
                      <Button
                        variant="secondary"
                        className="w-full"
                        onClick={handleSubmit}
                      >
                        Sign Up For Free
                      </Button>
                    </div>
                  )}

                  <div className="mt-5 ml-2">
                    <span
                      className="text-indigo-600 hover:underline cursor-pointer"
                      onClick={() => {
                        navigate("/auth/login");
                      }}
                    >
                      Already have an account? Login instead.
                    </span>
                  </div>
                </Form>
              </FormikProvider>
            </div>

            <p className=" text-primary-50 mt-3 mx-auto md:mx-0 text-center md:text-left xs:text-md xs:max-w-[450px] sm:text-lg sm:max-w-[450px] md:text-lg md:max-w-[500px] ">
              If you wish to stream only a single session yourself occasionally, it's better to install some aditional scripts on your BigBlueButton
               server with an onetime cost. It will allow you to Start and Stop a Live Stream with 
              some linux command from the server's SSH terminal. <a
                              href="https://bigbluebutton.host/lets-talk"
                              target="_blank"
                              rel="noreferrer"
                              className="transition-all cursor-pointer text-secondary-100 hover:underline hover:text-secondary-200"
                            >
                              Contact Us
                            </a> </p> 

          </div>

          {/* right side */}
          <div className=" flex justify-center items-center ml-auto w-full relative ">
            <img
              src="/static/BigBlueButton-Live-Streaming.png"
              className="md:absolute md:left-5  mt-10 sm:h-[250px] md:h-[350px] lg:h-[420px]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
